import { FC, ReactNode } from 'react';
import { PostHogProvider } from 'posthog-js/react';

const POSTHOG_KEY = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
const POSTHOG_HOST = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;

interface PostHogWrapperProps {
  children: ReactNode;
  enabled: boolean;
  apiKey?: string;
  apiHost?: string;
}
// PostHog configuration
const PostHogWrapper: FC<PostHogWrapperProps> = ({ 
  children, 
  enabled 
}) => {
  // Early return if PostHog is disabled or missing required config
  if (!enabled || !POSTHOG_KEY || !POSTHOG_HOST) {
    return <>{children}</>;
  }



  return (
    <PostHogProvider apiKey={POSTHOG_KEY}>
      {children}
    </PostHogProvider>
  );
};

export default PostHogWrapper;
